import React from "react"
import { useEffect, useState } from "react"
import { Divider, Form, Input, Radio, Select } from "antd"
import { UploadButtonForm } from "../../shared"
import { toFileList } from "../../../helpers"
import { getSelectValue } from "../../../helpers"
import { DateField } from "../../shared"
import { BeneficiariesService } from "../../../services"
import PropTypes from "prop-types"
import { getDistricts } from "../../../utils/districts-data-base"

CensusForm.propTypes = {
  form: PropTypes.object,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  submissionId: PropTypes.any
}

export function CensusForm ({ form, disabled = false, divider = true, submissionId, township, districts, setDistricts}) {

  const [options, setOptions] = useState ([])
  const [townshipOptions, setTownshipOptions] = useState([])
  const [loading, setLoading] = useState(false)

  const documents = form.getFieldValue("documents")

  useEffect(() => {
    if (documents?.length) {
      form.setFieldsValue({ documents })
    }
  }, [documents])

  useEffect(()  => {
    setTownshipOptions(township?.map((item)=>({value:item, label:item})))
    const getOptions = async() => {
       const submissionBeneficiaries =
       await BeneficiariesService().getBeneficiariesBySubmission({id: submissionId})
       const newOptions = submissionBeneficiaries.map(({id, name}) =>
       ({value: id, label: name || "sin nombre"})
      )
      setOptions(newOptions)
      }
      setLoading(true)
    getOptions().then().finally(() => setLoading(false))
  }, [])

  const getColony = (option) =>{
    
    const colony = getDistricts(option)
    
    setDistricts({data:colony.data, coloniesExist:colony.exist})
   
  }

  const onDoneFile = async files => {
    const documents = files?.map(el => {
      return { name: el.name, url: el.url }
    })

    try {
      form.setFieldsValue({ documents })
    }
    catch (e) {
      console.error(e)
    }
  }

  const onRemoveFile = async ({ url }) => {
    const oldDocuments = form.getFieldValue("documents")
    const documents = oldDocuments?.filter(document => document.url !== url)
    form.setFieldsValue({ documents })
  }
  
  return (
    <Form
      className="form"
      layout="vertical"
      form={form}>
      {divider && <Divider orientation="left">Información personal</Divider>}
      <Form.Item
        label="Nombre:"
        name="name"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Input name="name" disabled={disabled} />
      </Form.Item>
      <Form.Item
        label="Apellido 1:"
        name="lastName"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Input name="lastName" disabled={disabled} />
      </Form.Item>
      <Form.Item
        label="Apellido 2:"
        name="maidenName"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Input name="maidenName" disabled={disabled} />
      </Form.Item>
      <Form.Item
        label="Sexo:"
        name="gender"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Radio.Group disabled={disabled}>
          <Radio value="M">Masculino</Radio>
          <Radio value="F">Femenino</Radio>
          <Radio value="O">Prefiero no decirlo</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label="Fecha de nacimiento:"
        name="birthdate"
        getValueFromEvent={getSelectValue}
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <DateField
          id="birthdate"
          style={{ width: "100%" }}
          format="DD/MM/YYYY" disabled={disabled} />
      </Form.Item>
      <Form.Item
        label="CURP:"
        name="curp"
        rules={[
          { required: true, message: "El campo es requerido" },
          { validator: (_, value) => {
            const curpRegex = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/
            if (!value || curpRegex.test(value)) {
            return Promise.resolve() }
          return Promise.reject("El CURP no tiene un formato válido.") }}
        ]}>
      <Input name="curp" disabled={disabled} />
      </Form.Item>
      <Form.Item
        label="Teléfono:"
        name="phone"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Input name="phone" disabled={disabled} />
      </Form.Item>
      {divider && <Divider orientation="left">Dirección</Divider>}
      <Form.Item
        label="Estado:"
        name="state"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Input name="state" disabled={disabled} />
      </Form.Item>
      <Form.Item
        label="Municipio:"
        name="municipality"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Select
          name="municipality"
          allowClear
          showSearch
          placeholder="Seleccione el municipio"
          onChange={(e)=>getColony(e)}
          options={townshipOptions}
          optionFilterProp="label" />
      </Form.Item>
      <Form.Item
        label="Colonia:"
        name="colony"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        {
          districts.coloniesExist ?
          <Select
          name="colony"
          allowClear
          showSearch
          disabled={disabled}
          placeholder="Seleccione la colonia"
          options={districts.data}
          optionFilterProp="label" />
          :
          <Input name="colony" disabled={disabled} />
        }
      </Form.Item>
      {divider && <Divider orientation="left">Asignar a perfil de beneficiario</Divider>}
      <Form.Item
        name="beneficiaryProfileId"
        label="Perfil de beneficiario"
        rules={[{ required: true, message: "El campo es requerido" }]}>
        <Select
          allowClear
          showSearch
          placeholder="Seleccione perfil del beneficiario"
          options={options}
          loading={loading}
          optionFilterProp="label" />
        </Form.Item>
          {divider && <Divider orientation="left">Aviso de Privacidad</Divider>}
            <Form.Item
              name="documents"
              label="Documento de Aviso de Privacidad"
              help="El aviso de privacidad debe mencionar expresamente que se transferirán datos sensibles a Fundación FICOSEC, A.C."
              rules={[{ required: true, message: "El campo es requerido" }]} >
              <UploadButtonForm
                maxFile={1}
                onRemoveFile={onRemoveFile}
                onChange={onDoneFile}
                fileList={toFileList(documents)}>
                Adjuntar Documento
              </UploadButtonForm>
            </Form.Item>

    </Form>
  )
}
